const config = {
  development: {
    kambria: 'https://localhost:3000',
    bounty: 'https://localhost:3000',
    codebase: 'https://localhost:3000',
    store: 'https://localhost:3000',
  },
  staging: {
    kambria: 'https://staging-app.kambria.io',
    bounty: 'https://staging-bounty.kambria.io',
    codebase: 'https://staging-codebase.kambria.io',
    store: 'https://staging-store.kambria.io',
  },
  production: {
    kambria: 'https://app.kambria.io',
    bounty: 'https://bounty.kambria.io',
    codebase: 'https://codebase.kambria.io',
    store: 'https://store.kambria.io',
  },
};

export default config;
